const r=t=>{if(null===t)return"null";if(Array.isArray(t))return t.map(t=>r(t));if("object"==typeof t){const e={};for(const n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=r(t[n]));return e}return t};export{r as default};
